import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';

export default function ProfileDetailsGrid({ children }) {
  const items = Children.toArray(children);

  return (
    (<Grid container spacing={0}>
      <Grid size={4}>{items[2]}</Grid>
      <Grid container size={8}>
        <Grid size={12}>{items[0]}</Grid>
        <Grid size={12}>{items[1]}</Grid>
      </Grid>
      <Grid size={6}>{items[3]}</Grid>
      <Grid size={12}>{items[4]}</Grid>
      <Grid size={12}>{items[5]}</Grid>
      <Grid size={12}>{items[6]}</Grid>
    </Grid>)
  );
}

ProfileDetailsGrid.propTypes = {
  children: PropTypes.node,
};
